import React from 'react'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_back.svg'
import s from './ContactRoute.module.scss'

export const ContactRoute = ({ href, icon: Icon, tone, title, description, email, urgent }) => {
	const iconClass =
		tone === 'green' ? s.route__icon : `${s.route__icon} ${s[`route__icon--${tone}`]}`

	return (
		<a
			href={href}
			className={`${s.route} ${urgent ? s['route--urgent'] : ''}`.trim()}
		>
			<span className={iconClass}>
				<Icon aria-hidden />
			</span>
			<h2 className={s.route__title}>{title}</h2>
			<p className={s.route__description}>{description}</p>
			<span className={s.route__action}>
				<MailIcon aria-hidden />
				{email}
				<ArrowIcon className={s.route__actionArrow} aria-hidden />
			</span>
		</a>
	)
}

export default ContactRoute
